import { gql } from '@apollo/client'

export const GET_GROUP_EVENT = gql`
  query GroupEventAndStudentsForRsvpPage(
    $id: ID!
    $lessonId: ID!
    $contactId: ID!
  ) {
    groupEvents(id: $id) {
      id
      slug
      title
      description
      coachFacility {
        name
      }
      coach {
        name
        externalId
      }
      featuredImageUrl
      timezone
      tags
      sessions {
        id
        startDateTime
        endDateTime
      }
    }
    groupEventAttendeesByLesson(lessonId: $lessonId, contactId: $contactId) {
      enrollments(lessonId: $lessonId, contactId: $contactId) {
        id
        rsvpStatus
        student {
          firstName
          lastName
        }
      }
    }
  }
`

export const UPDATE_RSVP = gql`
  mutation UpdateEnrollmentRsvps($rsvps: [EnrollmentRsvpInput!]!) {
    updateEnrollmentRsvps(rsvps: $rsvps) {
      success
      message
      enrollments {
        id
        rsvpStatus
      }
    }
  }
`
